import { createContext, PropsWithChildren, useCallback, useRef } from 'react';

import { Constants, stub } from '@arrived/common';

export type NotifyMeButtonContextType = () => void;

export const NotifyMeButtonContext = createContext<NotifyMeButtonContextType>(stub);

/**
 * This provider wraps a button that is visibly hidden but can be triggered with the onClick function provided by the
 * context.
 *
 * This is necessary because on the Property page each card has a "Notify Me" button, however, Intercom only allows a
 * single element with that className to trigger on each page. This workaround allows us to keep the buttons on all the
 * cards
 */
export const NotifyMeButtonContextProvider = ({ children }: PropsWithChildren) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const onClick = useCallback(() => buttonRef.current?.click(), []);

  return (
    <NotifyMeButtonContext.Provider value={onClick}>
      <button
        ref={buttonRef}
        className={Constants.notifyMeButtonClassName}
        style={{ visibility: 'hidden', position: 'absolute' }}
        tabIndex={-1}
      />
      {children}
    </NotifyMeButtonContext.Provider>
  );
};
